// extracted by mini-css-extract-plugin
export default {"container":"GameWon_container__5tw6a"};